export default __webpack_public_path__ + "static/fwaenterprisebanner-8e42a8ea369f46b4b392396a55f8445b.mp4";